import React from 'react';
import { Link } from 'gatsby';

const FloorplanLink = ({ floorplanLink, avStatus }) => {
  const buttonClass =
    avStatus === 'Available Soon' || avStatus === 'Available Now'
      ? 'button is-success'
      : 'button is-danger';

  return (
    <Link to={floorplanLink} className={buttonClass}       
    style={avStatus === 'Contact Us' ? { backgroundColor: '#DBDBDB' } : {}}
    >
      {avStatus}
    </Link>
  );
};

export default FloorplanLink;
